export default "__VITE_ASSET__BMU8tneo__"